module.exports = __webpack_public_path__ + "img/title_img_hw.0ccd137a.png";